// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fXyyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconFacebook = require("./IconFacebook");
var _iconInstagram = require("./IconInstagram");
var _iconYoutube = require("./IconYoutube");
var _logoWrapper = require("./LogoWrapper");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _reactRouterDom = require("react-router-dom");
var _footerLiveMatch = require("./getMatches/FooterLiveMatch/FooterLiveMatch");
var _footerLiveMatchDefault = parcelHelpers.interopDefault(_footerLiveMatch);
const Footer = ()=>{
    const [thisAccount, setthisAccount] = (0, _react.useState)([]);
    const [usersession, setUsersession] = (0, _react.useState)("");
    const [watchalong, setWatchalong] = (0, _react.useState)(false);
    const [currentPage, setCurrentPage] = (0, _react.useState)(window.location.href);
    const [teams, setTeams] = (0, _react.useState)([
        "",
        ""
    ]);
    const [matchName, setMatchName] = (0, _react.useState)(null);
    const [videoUrl, setVideoUrl] = (0, _react.useState)(null);
    const [matchId, setMatchId] = (0, _react.useState)("");
    const [isMobile, setIsMobile] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        setIsMobile(mediaQuery.matches);
        const handleMediaQueryChange = (e)=>{
            setIsMobile(e.matches);
        };
        mediaQuery.addEventListener("change", handleMediaQueryChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleMediaQueryChange);
        };
    }, []);
    const pagePages = [
        {
            path: "/",
            label: "Home"
        },
        {
            path: "/support",
            label: "Support"
        },
        {
            path: "/match",
            label: "Matches"
        },
        {
            path: "/about",
            label: "About"
        },
        {
            path: "/play",
            label: "Play"
        },
        {
            path: "/contact",
            label: "Contact"
        },
        {
            path: "/media",
            label: "Media"
        }
    ];
    const handleSignout = async ()=>{
        (0, _jsCookieDefault.default).remove("c8_session_token");
        window.location.href = "/";
    };
    async function getUser(session_token) {
        try {
            const response = await fetch(`${"https://www.cricket8.com/api"}/verifysession/${session_token}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": "2AX6cermkFW0OkEvBzA0wX4cOTgCLwGt8Ufqyi8cS0IlITrny42Y9G9OhNs2UKe0"
                }
            });
            if (response.status === 200) {
                const data = await response.json();
                if (data) {
                    setUsersession(session_token);
                    data.verifychannel = data.verifychannel.trim();
                    setthisAccount(data);
                }
            } else {
                setUsersession("");
                return null;
            }
        } catch (error) {
            setUsersession("");
            return null;
        }
    }
    const fetchMatch = async (matchId)=>{
        const res = await fetch("https://www.cricket8.com/api" + `/fixturelist?match_id_contains=${matchId}&limit=1`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "2AX6cermkFW0OkEvBzA0wX4cOTgCLwGt8Ufqyi8cS0IlITrny42Y9G9OhNs2UKe0"
            }
        });
        if (res.status !== 200) {
            console.error("not ok result");
            return;
        }
        const data = await res.json();
        const matches = data?.matches;
        if (!matches || !matches?.length) return;
        const match = matches[0];
        const teamsNames = match?.name ? match.name.split(" v ") : [
            "",
            ""
        ];
        setTeams([
            teamsNames[0],
            teamsNames[1].split(",")[0]
        ]);
        setMatchName(match.name);
    };
    const fetch_settings = async ()=>{
        const response = await fetch(`${"https://www.cricket8.com/api"}/settings/watchalong`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "2AX6cermkFW0OkEvBzA0wX4cOTgCLwGt8Ufqyi8cS0IlITrny42Y9G9OhNs2UKe0"
            }
        });
        if (response.status === 200) {
            const data = await response.json();
            if (data && data.upcoming) {
                fetchMatch(data.upcoming.match_id);
                setMatchId(data.upcoming.match_id);
                setVideoUrl(data.upcoming.url);
                setWatchalong(true);
            } else setWatchalong(false);
        } else setWatchalong(false);
    };
    (0, _react.useEffect)(()=>{
        const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
        getUser(session_token);
        fetch_settings();
        return ()=>{};
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bg-header w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "sitefooter",
                className: "translate-y-[-50px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex md:justify-start justify-center md:items-start items-center h-[100px] md:left-[15px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoWrapper.LogoWrapper), {
                            className: "bg-[url(https://dyatkw7msrzcb.cloudfront.net/assets/image-1.png)] !w-[100px] !h-[100px]",
                            to: "/"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-6 md:flex md:flex-row md:justify-around md:items-start w-full",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                id: "col1",
                                className: "md:w-[300px] h-full flex flex-col items-center justify-start",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-full h-full mt-[10px] mb-[20px] text-center md:text-left text-[24px] [font-family:'Anton',Helvetica] font-normal text-transparent",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-white uppercase",
                                            children: [
                                                "The home of cricket",
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-lime uppercase",
                                                    children: "livestream "
                                                }),
                                                "media and ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-lime uppercase",
                                                    children: " games"
                                                })
                                            ]
                                        })
                                    }),
                                    isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: `/matchdetail?id=${matchId}#`,
                                        className: `bg-main border-[1px] border-red border-solid p-1 md:h-[85px] lg:flex w-[95%] ${watchalong === false ? "!hidden" : ""}`,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col md:flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row min-w-[23%] items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "w-[16px] h-[11px]",
                                                            alt: "Vector",
                                                            src: "/img/red_camera.png"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-red text-[12px]",
                                                            children: "LIVESTREAM"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerLiveMatchDefault.default), {
                                                        match_id: "1",
                                                        matchTime: "",
                                                        homeTeamName: teams[0],
                                                        awayTeamName: teams[1],
                                                        videoUrl: videoUrl
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex justify-center items-start p-4",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-full  grid grid-cols-2 gap-2 font-anton text-main text-[16px]",
                                    children: pagePages.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: item.path,
                                            onClick: ()=>window.scrollTo(0, 0),
                                            className: "footerlink font-chakra p-2 font-400 text-[16px]",
                                            style: {
                                                borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                                                borderTop: index < 2 ? "1px solid rgba(255, 255, 255, 0.2)" : "none"
                                            },
                                            children: item.label
                                        }, item.path))
                                })
                            }),
                            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `/matchdetail?id=${matchId}#`,
                                className: `bg-main border-[1px] border-red border-solid p-2 md:h-[100px] md:w-[250px] lg:flex ${watchalong === false ? "!hidden" : ""}`,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex md:flex-col w-full",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row min-w-[30%] items-center gap-[6px]",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "w-[16px] h-[11px]",
                                                    alt: "Vector",
                                                    src: "/img/red_camera.png"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-red text-[14px]",
                                                    children: "LIVESTREAM"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerLiveMatchDefault.default), {
                                            match_id: "1",
                                            matchTime: "",
                                            homeTeamName: teams[0],
                                            awayTeamName: teams[1],
                                            videoUrl: videoUrl
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "md:w-[270px] flex flex-row justify-center items-center p-4",
                                children: usersession === "" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "w-full flex flex-row justify-between items-center md:flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            className: "w-full",
                                            to: "/signup",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-anton text-main text-[16px] flex justify-center items-center bg-lime h-[40px] lg:h-[50px] lg:w-[197px]",
                                                children: "SIGN UP"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            className: "w-full",
                                            to: "/login",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-anton text-main text-[16px] flex justify-center items-center bg-lime h-[40px] lg:h-[50px] lg:w-[197px]",
                                                children: "LOGIN"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-[33px] w-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bg-lime h-[50px] md:w-full text-center cursor-pointer flex justify-center items-center",
                                        onClick: handleSignout,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-anton text-main text-[16px]",
                                            children: "SIGN OUT"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-[10px] w-[100%] h-[40px] justify-between items-center bg-[rgba(255,255,255,0.15)]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-[100%] px-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-grow flex items-center pl-[15px] [font-family:'Chakra_Petch',Helvetica] font-normal text-white text-[10px] tracking-[0] leading-normal justify-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-[0px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        className: "menuLink",
                                        to: "/terms",
                                        children: "Terms"
                                    }),
                                    "\xa0\xa0",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        className: "menuLink",
                                        to: "/privacy",
                                        children: "Privacy"
                                    }),
                                    "\xa0\xa0",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        className: "menuLink",
                                        to: "/terms#cookies",
                                        children: "Cookies"
                                    }),
                                    "\xa0\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                id: "social",
                                className: "w-[50%] flex justify-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex relative right-0",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://www.youtube.com/@Cricket8YT",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "w-[40px] h-[40px] ml-[3px] flex justify-center items-center bg-[rgba(255,255,255,0.2)] relative",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconYoutube.IconYoutube), {
                                                    className: "relative h-[15px] w-[20px]",
                                                    iconYoutube: "/img/icon-youtube.svg"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://www.facebook.com/Cricket8Official",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "w-[40px] h-[40px] ml-[3px] flex justify-center items-center bg-[rgba(255,255,255,0.2)] relative",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconFacebook.IconFacebook), {
                                                    className: "relative",
                                                    iconFacebook: "/img/icon-facebook.svg"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://www.instagram.com/Cricket8official/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "w-[40px] h-[40px] ml-[3px] flex justify-center items-center bg-[rgba(255,255,255,0.2)] relative",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconInstagram.IconInstagram), {
                                                    className: "relative",
                                                    iconInstagram: "/img/icon-instagram.svg"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.default = Footer;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./IconFacebook":"9Q7Xw","./IconInstagram":"fPDhu","./IconYoutube":"1MBJg","./LogoWrapper":"2z3Kx","js-cookie":"2P5RE","react-router-dom":"l6ORY","./getMatches/FooterLiveMatch/FooterLiveMatch":"6XLbI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Q7Xw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconFacebook", ()=>(0, _iconFacebook.IconFacebook));
var _iconFacebook = require("./IconFacebook");

},{"./IconFacebook":"3KOof","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KOof":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconFacebook", ()=>IconFacebook);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconFacebook = ({ className, iconFacebook = "/img/icon-facebook-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `absolute w-[10px] h-[20px] top-0 left-0 ${className}`,
        alt: "Icon facebook",
        src: iconFacebook
    });
};
IconFacebook.propTypes = {
    iconFacebook: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPDhu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconInstagram", ()=>(0, _iconInstagram.IconInstagram));
var _iconInstagram = require("./IconInstagram");

},{"./IconInstagram":"gqqNZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqqNZ":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconInstagram", ()=>IconInstagram);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconInstagram = ({ className, iconInstagram = "/img/icon-instagram-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `absolute w-[20px] h-[20px] top-0 left-0 ${className}`,
        alt: "Icon instagram",
        src: iconInstagram
    });
};
IconInstagram.propTypes = {
    iconInstagram: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MBJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconYoutube", ()=>(0, _iconYoutube.IconYoutube));
var _iconYoutube = require("./IconYoutube");

},{"./IconYoutube":"7VPkH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VPkH":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconYoutube", ()=>IconYoutube);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconYoutube = ({ className, iconYoutube = "/img/icon-youtube-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `absolute w-[27px] h-[20px] top-0 left-0 ${className}`,
        alt: "Icon youtube",
        src: iconYoutube
    });
};
IconYoutube.propTypes = {
    iconYoutube: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2z3Kx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogoWrapper", ()=>(0, _logoWrapper.LogoWrapper));
var _logoWrapper = require("./LogoWrapper");

},{"./LogoWrapper":"atxGR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atxGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogoWrapper", ()=>LogoWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
const LogoWrapper = ({ className, to })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        className: `w-[300px] h-[300px] bg-[url(https://dyatkw7msrzcb.cloudfront.net/assets/image-1.png)] bg-cover bg-[50%_50%] ${className}`,
        to: to
    });
};
LogoWrapper.propTypes = {
    to: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","react-router-dom":"l6ORY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XLbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FooterLiveMatches);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clubLogo = require("../../ClubLogo");
function FooterLiveMatches({ match_id, matchTime, homeTeamName, awayTeamName, videoUrl }) {
    const handleMatchClick = (matchId, localTime)=>{
        if (localTime === "LIVE") window.location = "/matchdetail?id=" + matchId;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `MatchCard ${matchTime === "LIVE" ? "cursor-pointer" : ""} relative w-full`,
        onClick: ()=>handleMatchClick(match_id, matchTime),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `schedule ${matchTime === "LIVE" ? "live" : ""}`,
                children: [
                    matchTime,
                    matchTime === "LIVE" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "live-indicator mr-[10px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "inner"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "name text-[11px] md:max-w-[60%] text-white font-chakra leading-[14px] max-w-[80%] md:overflow-visible md:whitespace-normal truncate",
                children: [
                    homeTeamName,
                    " v ",
                    awayTeamName
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex absolute md:top-[-30px] right-0 top-[-20px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "homeTeam md:w-[42px] md:h-[42px] w-[32px] h-[32px] mr-[-5px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clubLogo.ClubLogo), {
                            teamName: homeTeamName
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "awayTeam md:w-[42px] md:h-[42px] w-[32px] h-[32px] ml-[-5px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clubLogo.ClubLogo), {
                            teamName: awayTeamName
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../ClubLogo":"hyRbj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Footer.640f7596.js.map
